import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import {apiResponse} from "@/lib/types";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export const getFileFromBase64 = (
  string64: string,
  fileName: string,
  mimeType: string
) => {
  const trimmedString = string64.replace("dataimage/jpegbase64", "");
  const imageContent = trimmedString.replace(/\s/g, "");
  const buffer = new ArrayBuffer(imageContent.length);
  const view = new Uint8Array(buffer);

  for (let n = 0; n < imageContent.length; n++) {
    view[n] = imageContent.charCodeAt(n);
  }
  const type = mimeType;
  const blob = new Blob([buffer], { type });
  return new File([blob], fileName);
};

export const getBase64 = async (imageUrl: any) => {
  var res = await fetch(imageUrl);
  var blob = await res.blob();

  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.addEventListener(
      "load",
      function () {
        resolve(reader.result);
      },
      false
    );

    reader.onerror = () => {
      return reject(this);
    };
    reader.readAsDataURL(blob);
  });
};

export function formatDate(input: string | number): string {
  const date = new Date(input);
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

export function formatDateInsert(date: string | number | Date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2)
      month = '0' + month;
  if (day.length < 2)
      day = '0' + day;

  return [year, month, day].join('-');
}
export function paginationList(current: number, last: number, delta: number = 5,prev_str: string = 'prev', next_str: string = 'next', dot_str: string = '...') {
  if (last === 1) return [1];

  const left = current - delta,
    right = current + delta + 1,
    range = [];

  if (last > 1 && current !== 1) {
    range.push(prev_str);
  }

  for (let i = 1; i <= last; i++) {
    if (i == 1 || i == last || (i >= left && i < right)) {
      if (i === left && i > 2) {
        range.push(dot_str);
      }

      if (i === current) {
        range.push(i);
      } else {
        range.push(i);
      }

      if (i === right - 1 && i < last - 1) {
        range.push(dot_str);
      }
    }
  }

  if (last > 1 && current !== last) {
    range.push(next_str);
  }

  return range;
}

export function srcToFile(src: string | URL | Request, fileName: string, mimeType: any){
  const base = process.env.API_BASE_URL || '/api/';
  const url = base + String(src).replace(/^\/+/, '')

  return (fetch(url)
          .then(function(res){return res.arrayBuffer();})
          .then(function(buf){return new File([buf], fileName, {type:mimeType});})
  );
}

const blobUrlCache = new WeakMap<File, string>();
export  function getFileUrl(file: File | null | undefined) {
    if (!file) return null;
    let url = blobUrlCache.get(file);
    if (!url) {
        url = URL.createObjectURL(file);
        blobUrlCache.set(file, url);
    }
    return url;
};

export function isFile(input:any) {
  return 'File' in window && input instanceof File;
}

export function isBlob(input:any) {
  return 'Blob' in window && input instanceof Blob;
}
export function getFirstLetterOfEachWord(str: string) {
  if(str) {
    let matches = str.match(/\b(\w)/g);
    return matches?.join('') || '';
  }

  return  str;
}
export const cleanFormData = (formData:any) => {
  return Object.fromEntries(
      Object.entries(formData).filter(([_, value]) => value !== undefined)
  );
};

export function treeViewWithParentId(parentColumnName: string, data: Array<{ id: number; name: string; [key: string]: any }>, parentId: number): Array<{ id: number; name: string; children: Array<any> }> {
  const tree: Array<{ id: number; name: string; children: Array<any> }> = [];
  for (const item of data) {
    if (item[parentColumnName] === parentId) {
      const node = {
        id: item.id,
        name: item.name,
        children: treeViewWithParentId(parentColumnName, data, item.id)
      };
      tree.push(node);
    }
  }
  return tree;
}

export function arrayStringEqual(arr1:string[], arr2:string[]) {
  return JSON.stringify(arr1) === JSON.stringify(arr2);
}

export function isShowRole(role:any){
  return role === true || role === undefined || role === null;
}

/**
 * Sets form errors based on API response
 * @param res - API response containing errors or message
 * @param form - React Hook Form instance
 * @param fieldKeyMap - Optional mapping of field keys to form field names
 * @param defaultField - Default field to set error on if no specific field found (default: "name")
 * @param defaultMessage - Default error message if no specific message found
 */
export const handleFormErrors = <T extends Record<string, any>>(
    res: apiResponse,
    form: any,
    fieldKeyMap?: Record<string, string>,
    defaultField: keyof T = "name" as keyof T,
    defaultMessage: string = "Lỗi hệ thống. Hãy liên hệ với quản trị viên để được xử lý."
) => {
  if (res.errors) {
    for (const key in res.errors) {
      const obj = res.errors[key];
      let field_key = obj.field_key;
      let field_key_arr = field_key.split("[");
      let field_name = "";

      if (Array.isArray(field_key_arr)) {
        field_name = field_key_arr[0];
      } else if (typeof field_key_arr === "string") {
        field_name = field_key;
      }

      // Map field name if mapping exists
      if (fieldKeyMap && field_name in fieldKeyMap) {
        field_name = fieldKeyMap[field_name];
      }

      if (field_name !== "") {
        form.setError(field_name as keyof T, {
          type: "manual",
          message: obj.field_value,
        });
      } else {
        form.setError(defaultField, {
          type: "manual",
          message: obj.field_value ?? defaultMessage,
        });
      }
    }
  } else if (res.message) {
    form.setError(defaultField, {
      type: "manual",
      message: res.message ?? defaultMessage,
    });
  }

  return !res.status;
};

export function isNullOrEmpty(str: string | null | undefined): boolean {
    return str === null || str === undefined || str.trim().length === 0;
}

export const isNonEmptyString = (v: unknown): v is string => typeof v === "string" && v.trim().length > 0;

export function sanitizeParams(input: Record<string, any> = {}) {
    const out: Record<string, any> = {};
    for (const [k, v] of Object.entries(input)) {
        if (v === undefined || v === null) continue;

        if (typeof v === "string") {
            const s = v.trim();
            if (!s) continue;
            const low = s.toLowerCase();
            if (low === "undefined" || low === "null") continue;
            out[k] = s;
            continue;
        }

        if (typeof v === "number") {
            if (Number.isNaN(v)) continue;
            out[k] = v;
            continue;
        }

        // với boolean / object hợp lệ, giữ nguyên
        out[k] = v;
    }
    return out;
}

export function formatCurrency(amount: number) {
    if (amount == null || isNaN(amount)) return "0 VND";

    const abs = Math.abs(amount);

    if (abs >= 1_000_000_000) {
      return (amount / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + " tỷ VND";
    }

    if (abs >= 1_000_000) {
      return (amount / 1_000_000).toFixed(1).replace(/\.0$/, '') + " triệu VND";
    }

    if (abs >= 1_000) {
      return (amount / 1_000).toFixed(1).replace(/\.0$/, '') + " nghìn VND";
    }

    return amount.toLocaleString('vi-VN') + " VND";
}
